import Home from "@/components/Home.vue";

export const routes = [
    {
        path: '/ru', name: 'ru', component: Home, meta: { locale: 'ru' }
    },
    {
        path: '/en', name: 'en', component: Home, meta: { locale: 'en' }
    },
    {
        path: '/kk', name: 'kk_direct', component: Home, meta: { locale: 'kk' }
    },
    {
        path: '/', name: 'kk', component: Home, meta: { locale: 'kk' }
    },
    {
        path: '/:pathMatch(.*)*',
        redirect: { name: 'kk' },
    },
]
